// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"FittedImage_imageContainer__3HyLK","image":"FittedImage_image__2Bov8"};